<template>
  <div class="w-full h-full">
    <panel class="xl:h-full" with-header>
      <header slot="header" class="flex items-center border-b pb-4">
        <i class="fa fa-images fa-2x bg-tertiary text-white mr-6 p-3 rounded-lg"></i>
        <h1 class="text-black text-2xl font-semibold">Media library</h1>
        <button @click="closeMediaManager" type="button" class="w-24 px-4 py-1 flex items-center justify-center text-grey-lighter shadow hover:shadow-none bg-black ml-auto rounded ml-auto">
          <span><i class="fa fa-times"></i> Close</span>
        </button>
      </header>
        <div class="relative inline-flex flex-col w-1/3">
            <input type ="text" class="bg-white outline-none rounded h-11 p-3 shadow border mt-2" placeholder="Search" v-model="search"/>
        </div>
      <div class="mediaGallery flex flex-wrap inline-flex">
        <div class="galleryImages w-3/5 flex flex-wrap max-h-screen overflow-auto">
          <div v-if="media.length > 0 && loading == false" class="flex flex-wrap">
            <div class="relative inline-flex flex-col lg:1/4 p-1" v-for="(mediaItem, i) in filteredMedia" :key="i" :id="'media_'+i">
              <div v-if="!mediaItem.filetypeIcon"
              @click="previewMedia = mediaItem, previewMedia.index = i, getMediaDimensions(mediaItem.path)"
              class="overflow-hidden relative w-full h-32 bg-center bg-cover bg-no-repeat flex hover:border-green border-white border-4 white-frame"
              v-bind:style="{ 'background-image': 'url(' + mediaItem.path + ')' }"
              :class="{'border-green-lighter border-white border-4 white-frame': i === 0 && fileUploaded && !previewMedia}"
              >
              </div>

              <div v-if="mediaItem.filetypeIcon"
              @click="previewMedia = mediaItem, previewMedia.index = i, getMediaDimensions(mediaItem.path)"
              class="overflow-hidden relative w-full h-32 justify-center items-center flex hover:border-green border-white border-4 white-frame"
              :class="{'border-green-lighter border-white border-4 white-frame': i === 0 && fileUploaded && !previewMedia}"
              >
                <i class="fa fa-4x" :class="mediaItem.filetypeIcon"></i>
              </div>

              <div class="w-full bg-white text-center p-3 overflow-hidden">
                <p class="text-grey-dark break-words"><small>{{ mediaItem.filename }}</small></p>
              </div>
            </div>
          </div>
          <div v-else class="flex justify-center items-center w-full h-full">
            <loader v-if="loading" />
          </div>
        </div>

        <div class="flex flex-wrap w-2/5 inline-flex bg-grey-lighter p-4 overflow-auto">
          <div class="relative inline-flex flex-col w-full" v-if="previewMedia">
            <h2 class="text-black text-2xl font-semibold pb-4 m-4 border-b">Attachment Details</h2>
            <div class="flex w-full flex-row">
              <div class="inline-flex flex-col w-full md:w-1/2 p-1">
                <div v-if="!previewMedia.filetypeIcon"
                class="overflow-hidden relative w-full h-32 bg-center bg-cover bg-no-repeat flex"
                v-bind:style="{ 'background-image': 'url(' + previewMedia.path + ')' }">
                </div>

                <div v-if="previewMedia.filetypeIcon"
                class="overflow-hidden relative w-full h-32 justify-center items-center flex">
                  <i class="fa fa-4x" :class="previewMedia.filetypeIcon"></i>
                </div>
              </div>

              <div class="inline-flex flex-col w-full md:w-1/2 text-left p-3 overflow-hidden">
                <p class="text-black break-words">{{ previewMedia.filename }}</p>
                <p class="text-grey"><small>{{ previewMedia.width }} x {{ previewMedia.height }}</small></p>
                <div class="flex flex-end mt-6">
                  <a :href="previewMedia.path" target="_blank" class="mr-3 cursor-pointer no-underline text-grey-darkest"><i class="fa fa-search mr-1"></i> <span class="hidden sm:inline-block">Open</span></a>
                  <a @click="deleteMedia(previewMedia.path, previewMedia.index)" class="cursor-pointer"><i class="fa fa-trash mr-1"></i> <span class="hidden sm:inline-block">Delete</span></a>
                </div>
              </div>
            </div>
            <div class="inline-flex flex-col w-full text-left p-3 overflow-hidden border-t mt-4" v-if="previewMedia">
              <button @click="selectMedia(previewMedia)" type="button" class="w-full px-4 py-1 flex items-center justify-center text-grey-darkest rounded-lg shadow hover:shadow-none border border-blue bg-white">
                Select file
              </button>
            </div>
          </div>
          <div class="relative inline-flex flex-col w-full">
            <h2 class="text-black text-2xl font-semibold pb-4 m-4 border-b">Upload File</h2>
            <div class="flex w-full flex-row">
              <div class="inline-flex flex-col w-full p-1 p-4">
                <input @change="processFile" type="file" name="uploadMedia" id="uploadMedia" ref="mediaInput" class="">
              </div>
            </div>
            <div class="inline-flex flex-col w-full text-left p-3 overflow-hidden border-t mt-4">
              <button @click="confirmMedia" type="button" class="w-full px-4 py-1 flex items-center justify-center text-grey-darkest shadow hover:shadow-none bg-secondary ml-auto rounded">
                <span><i class="fa fa-upload"></i> Upload Media</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </panel>
    <div v-if="resposeData" class="text-center">
      <paginator v-if="resposeData" :data="paginatorMeta" @change="paginatorChanged" />
    </div>
    <div v-else>
      <loader v-if="!paginatorMeta.current_page" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import api from '@/http'

export default {
  name: 'media-manager',
  data () {
    return {
      previewMedia: null,
      selectedMedia: null,
      media: [],
      fileInput: false,
      search: '',
      resposeData: null,
      loading: true,
      fileUploaded: false,
      searchMedia: []
    }
  },
  computed: {
    filteredMedia: function () {
      if (this.search) {
        return this.searchMedia
      }
      return this.media
    },
    paginatorMeta: function () {
      let output = []

      if (!this.resposeData) {
        return output
      }
      return {
        current_page: this.resposeData.current_page,
        last_page: this.resposeData.last_page
      }
    }
  },
  watch: {
    'search': function () {
      this.fetchAllMedia()
    }
  },
  methods: {
    ...mapActions([
      'displayToastNotification'
    ]),
    selectMedia (selected) {
      this.selectedMedia = selected
      this.$emit('selected', this.selectedMedia)
    },
    closeMediaManager () {
      this.$emit('closeMediaManager')
    },
    confirmMedia (e) {
      let files = this.fileInput
      let data = new FormData()
      data.append('_method', 'POST')
      data.append('new_media', files)

      this.uploadMedia(data)
      this.fileUploaded = true
    },
    processFile (event) {
      this.fileInput = event.target.files[0]
    },
    uploadMedia (data) {
      api.post('/media/upload', data)
        .then(response => {
          this.fetchMedia(1)
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Uploaded',
            info: 'File uploaded'
          })
        })
        .catch((error) => {
          console.log('system', error)
        })
    },
    deleteMedia (data, index) {
      document.getElementById('media_' + index).style.display = 'none'
      api.post('/media/delete', { 'filepath': data })
        .then(response => {
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Delete',
            info: 'File deleted'
          })
        })
        .catch((error) => {
          console.log('system', error)
        })
    },
    fetchMedia (data) {
      this.loading = true
      api.get('/media/' + data, data).then(response => {
        this.media = response.data.data
        this.resposeData = response.data
        this.loading = false
        // context.commit('uploadMedia', response.data)
      })
    },
    getMediaDimensions (url) {
      var img = new Image()
      img.src = url
      this.previewMedia.height = img.height
      this.previewMedia.width = img.width
    },
    paginatorChanged (i) {
      this.page = i
      this.fetchMedia(i)
    },
    fetchAllMedia () {
      api.get('/media/all', { params: {
        search: this.search,
        page: 1
      }
      }).then(response => {
        this.searchMedia = response.data.data
      })
    }
  },
  created () {
    let page = 1
    this.fetchMedia(page)
  }
}
</script>

<style lang="scss" scoped>
  .modal-container {
    top: 50vh;
    left: 50%;
    transform: translate(-50%, -50%);
    min-height: 20vh;
    min-width: 20vw;
  }

  .mediaGallery > div .pathOverlay::before {
    content: '';
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;

    border-bottom: 10px solid #22292f;
    position: absolute;
    top: -9px;
    z-index: 2;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .mediaGallery > div:hover .pathOverlay {
    display: block;
    left: 50%;
    top: 20%;
    transform: translateX(-50%);
  }
  .white-frame::before {
    content: " ";
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    border: 3px solid #fff;
  }
</style>
